import { Injectable } from '@angular/core';
import { generateRandomString } from '../utils/RandomStringGenerator';
import { hashString } from '../utils/HashString';
import { ssoConfig } from '../config/sso.config';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class LoginRedirectionService {
 private readonly verifierKey = 'sso_code_verifier';
  private readonly challengeKey = 'sso_code_challenge';
  private readonly tokenKey = 'access_token';

  constructor() {}

  loginredirection(): void {
    const codeVerifier = generateRandomString(20);
    const codeChallenge = hashString(codeVerifier);

    localStorage.setItem(this.verifierKey, codeVerifier);
    localStorage.setItem(this.challengeKey, codeChallenge);

  let redirectUrl = ``;
    if(environment.production)redirectUrl = `${environment.SSO_URL}?appId=${ssoConfig.appId}&codeChallenge=${codeChallenge}`;
    else redirectUrl = `${environment.SSO_URL}?appId=${ssoConfig.appId}&codeChallenge=${codeChallenge}&returnUrl=${environment.localhostUrl}`;
    window.location.href = redirectUrl;
  }
}
